import React from 'react';

import { CardCvcElement } from '@stripe/react-stripe-js';
import type { StripeCardCvcElementChangeEvent } from '@stripe/stripe-js';

type Props = {
	onChange?: (event: StripeCardCvcElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const CardCvcElementWrapper: React.FC<Props> = ({ onChange, onFocus, onBlur }) => {
	return (
		<CardCvcElement
			options={{ style: { base: { fontSize: '16px' } } }}
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
		/>
	);
};
